import Trans from "features/translation/components/Trans";
import FilterControls from "features/view/components/Filters/FilterControls";
import ProfileTeaser from "pages/Profile/ProfileTeaser";
import Alert from "components/ui/Alert/Alert";
import Filters from "features/view/components/Filters/Filters";
import Empty from "features/view/components/Empty/Empty";
import Loader from "components/ui/Loader/Loader";
import { useView } from "features/view/context/ViewContext";
import ViewPager from "features/view/components/Pager/ViewPager";

const ViewProfiles = () => {
  const { view, isLoading } = useView();

  if (!isLoading && !view) {
    return <Alert/>;
  }

  let content = view?.search_results && view.search_results.map(
    (row, index) => <ProfileTeaser key={ index }
                                   name={ row.title }
                                   city={ row.field_profile_city }
                                   gender={ row.field_profile_gender }
                                   photo={ row.field_profile_photo }
                                   age={ row.field_profile_age }
                                   distance={ row.location_distance?.toString() }
                                   description={ row.field_profile_description }
                                   url={ row.url }
                                   created={ row.created }/>);
  if (!content) {
    content =
      <Empty><Trans text={ 'Er zijn geen profielen gevonden die aan alle filtervoorwaarden voldoen.' }/></Empty>;
  }

  return (
    <>
      <div className={ 'grid--filter' }>
        <Filters hasLocation={ true }/>
      </div>
      <div className={ 'grid--content' }>
        <FilterControls/>
        <div className={ 'teasers-container--2col' }>
          { isLoading ? <Loader containerVariant={ 'center' }/> : content }
        </div>
        <ViewPager/>
      </div>
    </>
  );
}

export default ViewProfiles;
